export default __webpack_public_path__ + "static/IN-5905HD_Lense-Adjustment-438aeb7aaea17988b515b43c06052128.png";